

import {Component, Prop, Vue} from "vue-property-decorator"
import {Verslagen} from "@/types/Verslagen";

@Component({})
export default class JaarverslagenListNL extends Vue {
  name!: "JaarverslagenListNL"

  @Prop()
  verslagen!: Array<Verslagen>;

  @Prop()
  jaarverslagenlink!: string;

}
